import { IkeUserRole } from '@ikegps/core-api';
import { MaterialIcon } from '../components/icon/icons';
import { T } from '../i18n';
import type { MithrilVNode } from '../mithril';
import { AccountsComponent } from '../modules/accounts/accounts';
import { AccountsCtrl } from '../modules/accounts/accounts.ctrl';
import { Services } from '../services';
import { IkePage, type IkePageConfig, IkePageName } from './page';

export const AccountsPageConfig: IkePageConfig = {
	type: 'internal',
	name: IkePageName.accountList,
	path: '/user/accounts',
	auth: {
		required: true,
		userLevel: [IkeUserRole.ROOT],
	},
	nav: {
		name: T.LIST_USER_ACCOUNTS,
		icon: MaterialIcon.PERSON,
	},
};

export class AccountsPage extends IkePage {
	name = 'AcceptInvite';

	private component: AccountsComponent;

	constructor() {
		super(AccountsPageConfig);
		const ctrl = new AccountsCtrl();
		this.component = new AccountsComponent(ctrl);
	}

	get nodes(): MithrilVNode {
		if (!Services.User.hasUser) {
			return null;
		}

		return this.component.view();
	}
}
